module.exports = __webpack_public_path__ + "img/1592.057845c4.png";